import { PricingTable } from "../../components/pricing-table/PricingTable";

const App = () => {
  return (
    <div className="w-full">
      <PricingTable />
    </div>
  );
};

export default App;
